module.exports = __webpack_public_path__ + "static/media/YM64_1.1a025851.jpg";